import { render } from "./Step_two.vue?vue&type=template&id=0cce272b"
import script from "./Step_two.vue?vue&type=script&lang=js"
export * from "./Step_two.vue?vue&type=script&lang=js"

import "./Step_two.vue?vue&type=style&index=0&id=0cce272b&lang=less"
script.render = render

export default script